import { defineStyleConfig } from '@chakra-ui/react';

var baseStyle = {
    bg: 'neutrals.700',
    color: 'neutrals.white',
    fontSize: '14px',
    fontWeight: '400',
    borderRadius: 'md',
    p: 3,
    ".chakra-tooltip__arrow": {
        bg: 'neutrals.700 !important',
        borderRadius: 'sm',
    },
};
var tooltipTheme = defineStyleConfig({ baseStyle: baseStyle });

export { tooltipTheme };
//# sourceMappingURL=tooltip.js.map
